let resumeData = {
  imagebaseurl: "https://techonoeticsclub.github.io/",
  name: "Srikanth Reddy Reddybathuni",
  role: "Full Stack Developer",
  linkedinId: "srikanth-reddy-reddybathuni-704468b9",
  skypeid: "srikanthreddyee",
  roleDescription:
    " I like dabbling in various parts of frontend development and like to learn about new technologies, write technical articles or simply play games in my free time.",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/srikanth-reddy-reddybathuni-704468b9/",
      className: "fa fa-linkedin"
    },
    {
      name: "github",
      url: "http://github.com/srikanthreddy919",
      className: "fa fa-github"
    }
  ],
  aboutme:
    "I have finished my B.Tech. in Electrical and have been working in IT industry for past few years. I like dabbling in various parts of frontend development and like to learn about new technologies, write technical articles or simply play games in my free time.",
  address: "India",
  website: "https://reddybathuni.com",
  education: [
    {
      UniversityName: "St. Mary' S Group Of Institutions Guntur (JNTUK)",
      specialization: "Electrical & Electronics Engineering",
      MonthOfPassing: "April",
      YearOfPassing: "2013",
      Achievements: "Successfull completed Bachelors Degree"
    },
    {
      UniversityName: "Bapatla Polytechnic college, Bapatla",
      specialization: "Electrical & Electronics Engineering",
      MonthOfPassing: "April",
      YearOfPassing: "2010",
      Achievements: "Successfull completed Diploma in Electrical"
    }
  ],
  work: [
    {
      CompanyName: "Invisalign India LLP",
      specialization: "Full Stack Developer",
      MonthOfLeaving: "Jan",
      YearOfLeaving: "2020",
      present: true,
      Achievements: "Currently Working"
    },
    {
      CompanyName: "Codecrux Web Technologies Pvt Ltd.",
      specialization: "Software Developer",
      MonthOfLeaving: "Dec",
      YearOfLeaving: "2019",
      Achievements:
        "As a Full Stack Developer worked on multiple technologies and contributed on Open source projects."
    }
  ],
  skillsDescription: "Your skills here",
  skills: [
    {
      skillname: "HTML5",
      percentage: 100
    },
    {
      skillname: "CSS",
      percentage: 100
    },
    {
      skillname: "Reactjs",
      percentage: 95
    },
    {
      skillname: "Ruby",
      percentage: 95
    },
    { skillname: "Ruby on Rails", percentage: 95 },
    { skillname: "Git", percentage: 100 },
    { skillname: "Postgresql", percentage: 95 },
    { skillname: "Mysql", percentage: 95 },
    { skillname: "Heroku", percentage: 100 },
    { skillname: "AWS", percentage: 80 }
  ],
  portfolio: [
    {
      name: "BarknLounge",
      description: "Web Application",
      imgurl: "images/portfolio/barknlounge.png"
    },
    {
      name: "Hiredgrad",
      description: "Web Application",
      imgurl: "images/portfolio/hiredgrad.png"
    },
    {
      name: "Razorops",
      description: "Web Application for CI/CD Systems",
      imgurl: "images/portfolio/razorops.png"
    },
    {
      name: "Hclub",
      description: "Web Application for Health Services",
      imgurl: "images/portfolio/hclub.png"
    },
    {
      name: "1Dossier",
      description: "Web Application",
      imgurl: "images/portfolio/1dossier.png"
    },
    {
      name: "Scraptap",
      description: "Web Application for Scrap Management",
      imgurl: "images/portfolio/scraptap.png"
    },
    {
      name: "Yjobs",
      description: "Web Application for jobs",
      imgurl: "images/portfolio/yjobs.png"
    }
  ],
  testimonials: [
    {
      description: "This is a sample testimonial",
      name: "Some technical guy"
    },
    {
      description: "This is a sample testimonial",
      name: "Some technical guy"
    }
  ]
};

export default resumeData;



// WEBPACK FOOTER //
// ./src/resumeData.js